module.exports = __webpack_public_path__ + "static/media/Paz Perez.f785c3ec.png";